import { render, staticRenderFns } from "./Quizzes.vue?vue&type=template&id=0cc241a9&"
import script from "./Quizzes.vue?vue&type=script&lang=js&"
export * from "./Quizzes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports